const user = {
	permissions: [],
	fname: '',
	pname: '',
	lname: '',
	isElectronicAppLevel: false,
	pin: null,
	id: null,
};

const userModule = {
	namespaced: true,
	state: {
		user: user,
		isLoggedOut: false,
	},
	getters: {
		getUser: state => state.user,
		getPermissions: state => state.user.permissions,
		getPin: state => state.user.pin,
		getUserId: state => state.user.id,
		isAdmin: state => state.user.isAdmin,
		isLoggedOut: state => state.isLoggedOut,
		isElectronicAppLevel: state => state.user.isElectronicAppLevel,
	},
	mutations: {
		SET_USER: ( state, user ) => {
			state.user = user;
		},
		SET_LOGOUT_TRUE: ( state ) => {
			state.isLoggedOut = true;
		},
		SET_LOGOUT_FALSE: ( state ) => {
			state.isLoggedOut = false;
		},
	},
	actions: {
		setUser: ( { commit }, value ) => {
			commit('SET_USER', user);
			commit('SET_USER', value);
		},
		resetUser: ( { commit } ) => {
			commit('SET_USER', user);
		},
		logoutUser: ( { commit } ) => {
			commit('SET_LOGOUT_TRUE');
		},
		loginUser: ( { commit } ) => {
			commit('SET_LOGOUT_FALSE');
		},
	},
};

export default userModule;
